import React from 'react';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';

import AbstractCmsElement from './AbstractCmsElementNew';


export default class CmsElementBarCounter extends AbstractCmsElement {
  constructor(props) {
    super(props);

    this.allowStateChange = true;

    this.state = {
      shown: false,
    };
  }

  shown = () => {
    if (this.allowStateChange) {
      this.setState({ shown: true });
    }
  };

  render() {
    const { shown } = this.state;

    const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';
    const now = this.getParamValue('progress', 50);

    const parallaxData = this.getParallaxData();

    const innerContent = (
      <div
        id={this.getMainId()}
        className={'ms-bar-counter ' + shownClass + this.getResponsiveClasses() + this.getCssClasses()}
        style={{ ...this.getBackgroundStyle() }}
      >
        {this.getElementStyle()}

        <span className="progress-title">{this.getParamValue('title', '')}</span>
        <div className="progress" style={{ backgroundColor: this.getParamValue('progressBackgroundColor', '#dddddd') }}>
          <div
            className="progress-bar"
            style={{
              width: (shown ? now : 0) + '%',
              backgroundColor: this.getParamValue('barBackgroundColor', '#48b0f7'),
              color: this.getParamValue('color', '#fff'),
            }}
          >
            {now + '%'}
          </div>
        </div>

        {this.getAppendHtml()}
      </div>
    );

    return (
      <CustomScrollTrigger className="cms-overflow-fix" onEnter={this.shown} {...this.getCustomId()}>
        {parallaxData ? (
          <Parallax {...parallaxData}>
            {innerContent}
          </Parallax>
        ) : (
          innerContent
        )}
      </CustomScrollTrigger>

    );
  }
}
CmsElementBarCounter.defaultProps = {
  index: '0',
};
